import { Pais } from './pais.model';

export class CorreoElectronico {

    id: number;
    prefijo: string;
    dominio: string;
    correo: string;
    
    /**
     * Constructor
     *
     * @param correo
     */
    constructor(correo)
    {
        {
            this.id = correo.id || null;
            this.prefijo = correo.prefijo || '';
            this.dominio = correo.dominio || '';
            this.correo = correo.correo || '';
            
        }
    }
}
